import { render, staticRenderFns } from "./publishRFCCloseNum.vue?vue&type=template&id=4ee58220&scoped=true&"
import script from "./publishRFCCloseNum.vue?vue&type=script&lang=js&"
export * from "./publishRFCCloseNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee58220",
  null
  
)

export default component.exports